module.exports = {
    cruRole: "CRU",
    faRole:"FA",
    rmRole:"RM",
    risRole:"RIS",
    opsRole:"Ops",
    issRole:"ISS",
    treatAsFaRole:["FA", "RM"],
    cruNewStatus:"New",
    cruEscalatedStatus:"Escalated",
    cruCloseStatus:"Closed",
    cruRequestDetailsStatus: "Details Requested",
    cruRequestResubmitted:"Resubmitted",
    cruRequestDocumentsStatus: "Documents Requested",
    cruGeneralRequestStatus: "General Request",
    cruDocumentsUploaded: "Documents Uploaded",
    cruCaseAssignMessage:"Case has been assigned to you successfully.",
    cruCaseAssignErrorMessage:"Error occurred while assigning case. Please contact system administrator.",
    cruCaseEscalateMessage:"Case has been escalated successfully",
    cruCaseEscalateErrorMessage:"Error occurred while escalating the case. Please contact system administrator.",
    cruCaseReviewMessage:"Case has been Reviewed successfully.",
    cruCaseReviewErrorMessage:"Error occurred while sending the case back to CRU. Please contact system administrator.",
    cruCaseCloseMessage:"Case has been closed successfully.",
    cruCaseCloseErrorMessage:"Error occurred while closing the case. Please contact system administrator.",
    cruCaseRequestDetailsMessage:"Requested data for the case successfully.",
    cruCaseRequestDetailsErrorMessage:"Error occurred while requesting data for the case. Please contact system administrator.",
    cruCaseReasonCodes:["Decline","Postpone","Withdraw","Request New Case"],
    cruFATaskCompleteMessage:"Task completed successfully.",
    cruFATaskCompleteErrorMessage:"Error occured while completing the task. Please contact system administrator.",
    cruReassignSuccessMessage: "Reassigned case successfully.",
    cruReassignFailureMessage: "Error occured while reassigning the case. Please contact system administrator.",
    cruFilterDateValidationMessage:"Date should be on or after 01/01/2020 and on or before current date.",
    questions: [
        {
        question: "Will the source of premium for this policy come from a qualified account (401k, IRA, Roth IRA, 403b, etc.)?",
        answer: "Yes",
        questionToSend: ""
        },
        {
        question: "Will the source of premium for this policy come from a qualified account (401k, IRA, Roth IRA, 403b, etc.)?",
        answer: "No",
        questionToSend: ""
        },
        {
        question: "Will the source of premium for this policy come from a qualified account (401k, IRA, Roth IRA, 403b, etc.)?",
        answer: "No",
        questionToSend: ""
        },
        {
        question: "Will the source of premium for this policy come from a qualified account (401k, IRA, Roth IRA, 403b, etc.)?",
        answer: "Yes",
        questionToSend: ""
        }
    ],
    cruApprovalSuccessMessage:"Case Approved successfully.",
    cruConditionalApprovalSuccessMessage:"Case Conditionally Approved successfully.",
    cruApprovalErrorMessage:"Error occurred while assigning case. Please contact system administrator.",
    NoteMessages: {
        saveNoteSuccess : "Note Added Successfully.",
        saveNoteFailure: "Something went wrong while saving Note, Try again."
    },
    Upload: {
        fileUploadSuccess: "File uploaded Successfully.",
        fileUploadFailure: "Something went wrong while uploading file, Try again."
    },
    detailsReply: {
        detailsReplySuccess: "Details replied Successfully.",
        detailsReplyFailure: "Something went wrong while replying details, Try again.",
        detailsReplyValidationFailure: "Please fill all the answers."
    },
    requestDetails: {
        requestDetailsSuccess: "Request sent Successfully.",
        requestDetailsFailure: "Something went wrong while sending request, Try again.",
        requestDetailsValidationFailure: "No data is selected to send (or) all fields are not filled."
    },
    saveProgress: {
        saveSuccess: "Saved Successfully.",
        saveFailure: "Something went wrong while saving questions/comments, Try again.",
        saveValidationFailure: "No data is added to save (or) all fields are not filled."
    },
    cruStandardDate: "01/01/2020",
    serverIANATimezoneString: "America/Boise",
    displayLabels: {
      financialAdvisor: "Financial Advisor",
      rm: "Wealth Relationship Manager",
      pi: "Proposed Insured",
      cruPrincipal: "CRU Supervisory Principal",
      proposedOwner: "Proposed Owner",
      caseManager: "Case Manager",
      insuranceSalesConsultant: "Insurance Sales Consultant"
    },
    disclosureDelivery: {
        DDIsNotRequired: "DD is not required for this recommendation",
        DDIsNotAvailable: "DD is not available for selection",
    }
}


// WEBPACK FOOTER //
// ./src/constants.js